import Typography from "@mui/material/Typography";
// import Stemicon from '../../../images/stemicon.png';
// import Robo from '../../../images/Robo.png';
import { useTheme, useMediaQuery, Box } from "@mui/material";
import { motion } from "framer-motion";

export default function StemInAction() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return (
        <Box sx={{padding:'5%', backgroundColor: '#f7f9fc', overflowX: 'hidden' }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },  // <-- mobile: column, desktop: row
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 4
                }}
            >
                {/* Text Section */}
                <Box sx={{
                    flex: 1,
                    width: { xs: '100%', md: '70%' }
                }}>
                    <motion.div
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <Typography
                            sx={{
                                fontSize: { xs: '36px', sm: '48px', md: '72px', lg: '96px' },
                                fontWeight: 900,
                                fontFamily: "Montserrat",
                                color: '#3165F6',
                                mb: 4,
                                textAlign: { xs: 'center', md: 'left' },
                                wordBreak: 'break-word'
                            }}
                        >
                            STEM IN ACTION
                        </Typography>

                        <Box
                            sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '32px',
                                justifyContent: isMobile ? 'center' : 'flex-start'
                            }}
                        >
                            {[
                                {
                                    title: "Hard Concepts = Easy Wins",
                                    desc: "Toughest STEM ideas click faster when you build, code, and experiment."
                                },
                                {
                                    title: "Real-World Ready",
                                    desc: "Tackle projects that mirror actual tech, engineering, and science challenges."
                                },
                                {
                                    title: "Skills That Stick",
                                    desc: "You won’t just memorize—you’ll master by making, creating, and applying."
                                },
                                {
                                    title: "Team Hustle",
                                    desc: "Collaborate like pros, because innovation never happens alone."
                                }
                            ].map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        flex: '1 1 calc(50% - 16px)',
                                        minWidth: isMobile ? '100%' : '250px',
                                        boxSizing: 'border-box'
                                    }}
                                >
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.6, delay: 0.2 }}
                                        viewport={{ once: true }}
                                        style={{ display: 'flex', alignItems: 'flex-start' }}
                                    >
                                        <img src="https://dbqa318yoj3nn.cloudfront.net/stemicon.png" alt="icon" style={{ marginRight: 12, width: 34, height: 34 }} />
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Montserrat',
                                                    fontSize: { xs: '18px', sm: '20px', md: '24px' },
                                                    fontWeight: 600,
                                                    color: '#1B1B1B',
                                                    mb: 0.5
                                                }}
                                            >
                                                {item.title}
                                            </Typography>
                                            <Typography
                                                sx={{
                                                    fontFamily: 'Poppins',
                                                    fontSize: '15px',
                                                    color: '#1B1B1B'
                                                }}
                                            >
                                                {item.desc}
                                            </Typography>
                                        </Box>
                                    </motion.div>
                                </Box>
                            ))}
                        </Box>
                    </motion.div>
                </Box>

                {/* Robot Image Section */}
                <Box
                    sx={{
                        flex: '0 0 auto',
                        width: { xs: '100%', md: '30%' },
                        textAlign: { xs: 'center', md: 'right' }
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, x: 80 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.6, delay: 0.3 }}
                        viewport={{ once: true }}
                    >
                        <img src="https://dbqa318yoj3nn.cloudfront.net/Robo.png" alt="Robo" style={{ maxWidth: '100%', height: 'auto' }} />
                    </motion.div>
                </Box>
            </Box>
        </Box>
    );
}
